﻿import * as Cookie from 'js-cookie';
import tagManagerService from '../Services/TagManagerService';
import stateHandler, { STATE_CHANGED } from '/Scripts/Handlers/StateHandler';

class Cookiebar {
  constructor() {
    this.tagManagerService = tagManagerService;
    this.element = document.querySelector('.js--cookiebar');
    this.acceptedCookieName = '';
    this.defaultCookieGroup = '';
    this.accepted = null;
    this.setup();
    this.eventListener();

    stateHandler.on(STATE_CHANGED, this._stateUpdated);
  }

  eventListener = () => {
    const targets = document.querySelectorAll('[data-target]');
    targets.forEach(target => {
      target.addEventListener('click', (event) => this.onAccept(event));
    });
  }

  setup() {
    if (!this.element) {
      return;
    }

    this.acceptedCookieName = this.element.attributes['data-cookie-notice-dismissed-name'].value;
    this.defaultCookieGroup = this.element.attributes['data-default-cookie-group'].value;
    this.accepted = Cookie.get(this.acceptedCookieName);

     if (!this.accepted) {
      this.element.classList.add('cookiebar--visible');
    } 
  }

  onAccept = (e) => {
    e.preventDefault();

    let cookieGroupName = e.target.attributes['data-cookie-allowed-group-name'].value;

    if (cookieGroupName !== this.defaultCookieGroup) {
      cookieGroupName = [this.defaultCookieGroup, cookieGroupName].join(',').replace('"', '');
      if (tagManagerService) {
        tagManagerService.dispatchAnalyticsEvent(true, 'has_ga_cookie_consent');
      }
      stateHandler.changeState({
        cookieConsent: true
      });
    } 

    if (this.element && this.element.classList.contains('cookiebar--visible')) {
      this.element.classList.remove('cookiebar--visible');
    }
      
    Cookie.set(this.acceptedCookieName, cookieGroupName, { expires: 365 });


    }

    _stateUpdated = (next, previous) => {
      if (next.cookieConsent && this.element.classList.contains('cookiebar--visible')) {
        this.element.classList.remove('cookiebar--visible');
      }
    }
}

export default Cookiebar;